import { Route, Routes } from "react-router-dom";
import UnprotectedRoute from "../pages/UnprotectedRoute";
import ProtectedRoute from "../pages/ProtectedRoute";
import {
  AdminCreate,
  AdminList,
  ResetPassword,
  Dashboard,
  ForgetPassword,
  Login,
  OrganisationCreate,
  OrganisationList,
  AdminEdit,
  OrganisationEdit,
  GymList,
  GymCreate,
  GymEdit,
  StaffList,
  StaffCreate,
  StaffEdit,
  ScreenList,
  Billing,
  PaymentDetails,
  ExerciseList,
  ExerciseCreate,
  SessionCreate,
  SessionList,
  Schedule,
  ExerciseEdit,
  SessionFormatBuilder,
  SessionBlocksBuilder,
  SessionMetricsBuilder,
  SessionSummaryBuilder,
  SessionPreview,
  DeviceList,
  SubscriberList,
  SubscriberCreate,
  SubscriberEdit,
  Category,
  CategoryList,
  EquipmentList,
  Equipment,
  FormatList,
  Format,
  GroupList,
  Group,
  MetricsList,
  Metrics,
  MusclesList,
  Muscles,
  SegmentsList,
  Segments,
  TiersList,
  Tiers,
  PlanList,
  PlanCreate,
  Tax,
} from "../pages";
import NotFound from "../components/NotFound";
import SessionView from "../pages/workouts/Sessions/SessionView";
import ThemeSettings from "../pages/settings/themeSettings";
import CreateTheme from "../pages/settings/CreateTheme";

export const adminRoutes = {
  dashboard: "/",
  login: "/login",
  forgetPassword: "/forget-password",
  resetPassword: "/reset-password/:token",
  adminList: "/admin",
  adminCreate: "/admin/create",
  adminEdit: "/admin/:id",
  deviceList: "/device",
  organisationList: "/organisation",
  organisationCreate: "/organisation/create",
  organisationEdit: "/organisation/:orgid",
  gymList: "/gym",
  gymCreate: "/gym/create",
  gymEdit: "/gym/:gymid",
  staffList: "/staff",
  staffCreate: "/staff/create",
  staffEdit: "/staff/:staffid",
  screenList: "/screens",
  billing: "/billing",
  payment: "/payment-details",
  planList: "/plans",
  planCreate: "/plan/create",
  planEdit: "/plan/:id",
  exerciseList: "/exercise",
  exerciseCreate: "/exercise/create",
  exerciseEdit: "/exercise/:exerciseid",
  sessionList: "/session",
  sessionCreate: "/session/create",
  sessionEdit: "/session/:sessionid",
  sessionFormatBuilder: "/session/format-builder/:sessionid",
  sessionBlocksBuilder: "/session/blocks-builder/:sessionid",
  sessionMetricsBuilder: "/session/metrics-builder/:sessionid",
  sessionSummaryBuilder: "/session/summary-builder/:sessionid",
  sessionPreview: "/session/preview/:sessionid",
  sessionView: "/session/view/:sessionid",
  schedule: "/schedule",
  subscriberList: "/subscriber",
  subscriberCreate: "/subscriber/create",
  subscriberEdit: "/subscriber/:subscriberid",
  categoryList: "/category",
  categoryCreate: "/category/create",
  categoryEdit: "/category/:categoryid",
  equipmentList: "/equipment",
  equipmentCreate: "/equipment/create",
  equipmentEdit: "/equipment/:equipmentid",
  formatList: "/format",
  formatCreate: "/format/create",
  formatEdit: "/format/:formatid",
  groupList: "/group",
  groupCreate: "/group/create",
  groupEdit: "/group/:groupid",
  metricsList: "/metrics",
  metricsCreate: "/metrics/create",
  metricsEdit: "/metrics/:metricid",
  musclesList: "/muscles",
  musclesCreate: "/muscles/create",
  musclesEdit: "/muscles/:muscleid",
  segmentsList: "/segments",
  segmentsCreate: "/segments/create",
  segmentsEdit: "/segments/:segmentid",
  tiersList: "/tiers",
  tiersCreate: "/tiers/create",
  tiersEdit: "/tiers/:tierid",
  tax: "/tax",
  themeSettings: "/theme-settings",
  createTheme: "/theme-settings/create",
  editTheme: "/theme-settings/:themeid",
};

const AdminRouter = () => {
  return (
    <Routes>
      <Route element={<UnprotectedRoute />}>
        <Route path={adminRoutes.login} element={<Login />} />
        <Route path={adminRoutes.forgetPassword} element={<ForgetPassword />} />
        <Route path={adminRoutes.resetPassword} element={<ResetPassword />} />
      </Route>
      <Route element={<ProtectedRoute />}>
        <Route path={adminRoutes.dashboard} element={<Dashboard />} />
        <Route path={adminRoutes.adminList} element={<AdminList />} />
        <Route path={adminRoutes.adminCreate} element={<AdminCreate />} />
        <Route path={adminRoutes.adminEdit} element={<AdminEdit />} />
        <Route path={adminRoutes.deviceList} element={<DeviceList />} />

        <Route
          path={adminRoutes.organisationList}
          element={<OrganisationList />}
        />
        <Route
          path={adminRoutes.organisationCreate}
          element={<OrganisationCreate />}
        />
        <Route
          path={adminRoutes.organisationEdit}
          element={<OrganisationEdit />}
        />
        <Route path={adminRoutes.gymList} element={<GymList />} />
        <Route path={adminRoutes.gymCreate} element={<GymCreate />} />
        <Route path={adminRoutes.gymEdit} element={<GymEdit />} />
        <Route path={adminRoutes.staffList} element={<StaffList />} />
        <Route path={adminRoutes.staffCreate} element={<StaffCreate />} />
        <Route path={adminRoutes.staffEdit} element={<StaffEdit />} />
        <Route path={adminRoutes.screenList} element={<ScreenList />} />
        <Route path={adminRoutes.billing} element={<Billing />} />
        <Route path={adminRoutes.payment} element={<PaymentDetails />} />
        <Route path={adminRoutes.planList} element={<PlanList />} />
        <Route path={adminRoutes.planCreate} element={<PlanCreate />} />
        <Route path={adminRoutes.planEdit} element={<PlanCreate />} />
        <Route path={adminRoutes.tax} element={<Tax />} />
        <Route path={adminRoutes.exerciseList} element={<ExerciseList />} />
        <Route path={adminRoutes.exerciseCreate} element={<ExerciseCreate />} />
        <Route path={adminRoutes.exerciseEdit} element={<ExerciseEdit />} />
        <Route path={adminRoutes.sessionList} element={<SessionList />} />
        <Route path={adminRoutes.sessionCreate} element={<SessionCreate />} />
        <Route path={adminRoutes.sessionEdit} element={<SessionCreate />} />
        <Route
          path={adminRoutes.sessionFormatBuilder}
          element={<SessionFormatBuilder />}
        />
        <Route
          path={adminRoutes.sessionBlocksBuilder}
          element={<SessionBlocksBuilder />}
        />
        <Route
          path={adminRoutes.sessionMetricsBuilder}
          element={<SessionMetricsBuilder />}
        />
        <Route
          path={adminRoutes.sessionSummaryBuilder}
          element={<SessionSummaryBuilder />}
        />
        <Route path={adminRoutes.sessionView} element={<SessionView />} />
        <Route path={adminRoutes.sessionPreview} element={<SessionPreview />} />
        <Route path={adminRoutes.schedule} element={<Schedule />} />
        <Route path={adminRoutes.subscriberList} element={<SubscriberList />} />
        <Route
          path={adminRoutes.subscriberCreate}
          element={<SubscriberCreate />}
        />
        <Route path={adminRoutes.subscriberEdit} element={<SubscriberEdit />} />
        {/* Workout Library Routes */}
        <Route path={adminRoutes.categoryList} element={<CategoryList />} />
        <Route path={adminRoutes.categoryCreate} element={<Category />} />
        <Route path={adminRoutes.categoryEdit} element={<Category />} />
        <Route path={adminRoutes.equipmentList} element={<EquipmentList />} />
        <Route path={adminRoutes.equipmentCreate} element={<Equipment />} />
        <Route path={adminRoutes.equipmentEdit} element={<Equipment />} />
        <Route path={adminRoutes.formatList} element={<FormatList />} />
        <Route path={adminRoutes.formatCreate} element={<Format />} />
        <Route path={adminRoutes.formatEdit} element={<Format />} />
        <Route path={adminRoutes.groupList} element={<GroupList />} />
        <Route path={adminRoutes.groupCreate} element={<Group />} />
        <Route path={adminRoutes.groupEdit} element={<Group />} />
        <Route path={adminRoutes.metricsList} element={<MetricsList />} />
        <Route path={adminRoutes.metricsCreate} element={<Metrics />} />
        <Route path={adminRoutes.metricsEdit} element={<Metrics />} />
        <Route path={adminRoutes.musclesList} element={<MusclesList />} />
        <Route path={adminRoutes.musclesCreate} element={<Muscles />} />
        <Route path={adminRoutes.musclesEdit} element={<Muscles />} />
        {/* Subscriber Management Routes */}
        <Route path={adminRoutes.segmentsList} element={<SegmentsList />} />
        <Route path={adminRoutes.segmentsCreate} element={<Segments />} />
        <Route path={adminRoutes.segmentsEdit} element={<Segments />} />
        <Route path={adminRoutes.tiersList} element={<TiersList />} />
        <Route path={adminRoutes.tiersCreate} element={<Tiers />} />
        <Route path={adminRoutes.tiersEdit} element={<Tiers />} />

        <Route path={adminRoutes.themeSettings} element={<ThemeSettings />} />

        <Route path={adminRoutes.createTheme} element={<CreateTheme />} />
        <Route path={adminRoutes.editTheme} element={<CreateTheme />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AdminRouter;
